/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Listen_Go_QuestionInputs */

const en_onboarding_listen_go_question = /** @type {(inputs: Onboarding_Listen_Go_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where would you like to listen on the go?`)
};

const es_onboarding_listen_go_question = /** @type {(inputs: Onboarding_Listen_Go_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde te gustaría escuchar mientras caminas?`)
};

/**
* | output |
* | --- |
* | "Where would you like to listen on the go?" |
*
* @param {Onboarding_Listen_Go_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_listen_go_question = /** @type {((inputs?: Onboarding_Listen_Go_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Listen_Go_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_listen_go_question(inputs)
	return en_onboarding_listen_go_question(inputs)
});